import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const ideationMapsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/ideation/maps",
  component: lazyRouteComponent(
    () => import("@l30/web-atlas/pages/ideation.maps.page"),
    "IdeationMapsPage",
  ),
});
